export default __webpack_public_path__ + "img/555adbde57b5902c9a825ef79949e481.png";